import { type FC, useCallback } from "react";
import { type Path } from "react-hook-form";

import { isExperience } from "@ds/modules/experiences/utils/model";
import { isDropdownFormationProperty } from "@ds/modules/settings/projects/utils/formation-guards";

import { AggregatedValue } from "@ds/components/entities";
import { getProperty } from "@ds/utils/properties";

export const FormationDropdownDisplayValue: FC<{
  entity: Experience | Project;
  field: string;
  property: EntityFormationProperty | TemplateFormationProperty;
  isDirty?: boolean;
}> = ({ entity, field, property, isDirty = false }) => {
  const fieldPath = isExperience(entity)
    ? (`formation.properties.${field}.value` as const)
    : (`template.experience_formation.properties.${field}.value` as const);

  const dropdownFormatter = useCallback(
    (formatterEntity: Experience | Project, formatterField: Path<Experience | Project>) => {
      if (!isDropdownFormationProperty(property)) {
        return null;
      }

      const rawValue = getProperty(formatterEntity, formatterField);

      if (!rawValue) {
        return null;
      }

      // Find the option matching the raw value
      const selectedOption = property.metadata?.options?.find(item => item.value === rawValue);

      // Return label if available, otherwise fallback to raw value
      return selectedOption?.label || rawValue;
    },
    [property],
  );

  return (
    <AggregatedValue entity={entity} field={fieldPath} shouldShowEditedValue={isDirty} formatter={dropdownFormatter} />
  );
};
